export const NOTES_CHARACTER_LIMIT = 300;
export const PROJECT_NOTES_CHARACTER_LIMIT = 1000;
